import React from 'react';
import PropTypes from 'prop-types';
import CardIcon from './CardIcon';
import CardLink from './CardLink';
import {
  Content as CardContent,
  Thumbnail as CardThumbnail,
  ThumbnailCover,
  ThumbnailVideo,
} from './components';
import { StyledCard } from './styled';


class Card extends React.PureComponent {
  static defaultProps = {
    compact: false,
  };

  static propTypes = {
    a11yLabel: PropTypes.string,
    accent: PropTypes.string,
    actionLabel: PropTypes.string,
    compact: PropTypes.bool.isRequired,
    description: PropTypes.string,
    icon: PropTypes.func,
    link: PropTypes.string,
    onClick: PropTypes.func,
    subtitle: PropTypes.string,
    thumbnail: PropTypes.string,
    thumbnailAlign: PropTypes.string,
    title: PropTypes.string.isRequired,
    type: PropTypes.oneOf(
      [undefined, 'cover', 'icon', 'link', 'video']
    ),
    video: PropTypes.shape({
      duration: PropTypes.string,
      src: PropTypes.string.isRequired,
    }),
  };

  render() {
    const {
      a11yLabel,
      accent,
      actionLabel,
      compact,
      description,
      icon,
      link,
      target,
      onClick,
      subtitle,
      thumbnail,
      thumbnailAlign,
      title,
      type,
      video,
      ...rest,
    } = this.props;

    const appearanceProps = {
      compact,
      type
    };

    let Thumbnail;
    switch (type) {
      case 'cover':
        Thumbnail = (
          <ThumbnailCover
            data-thumb
            key='card-thumbnail'
            {...appearanceProps}
            image={thumbnail}
            imageAlign={thumbnailAlign}
            title={title}
            onClick={() => {}}
          />
        );
        break;
      case 'video':
        const {src, duration} = video || {};
        Thumbnail = (
          <ThumbnailVideo
            data-thumb
            key='card-thumbnail'
            {...appearanceProps}
            duration={duration}
            onPlayClick={onClick}
            a11yLabel={a11yLabel}
            poster={thumbnail}
            posterAlign={thumbnailAlign}
            src={src}
          />
        );
        break;
      default:
        Thumbnail = thumbnail && (
          <CardThumbnail
            data-thumb
            key='card-thumbnail'
            {...appearanceProps}
            image={thumbnail}
            imageAlign={thumbnailAlign}
            /* Note: Atribūts abu iespējamo scenāriju
            saglabāšanai – 16:9 vai ar noteiktu augstumu */
            fixedRatio
          />
        );
    }

    let Content;
    switch (type) {
      case 'cover':
      case 'icon':
      case 'link':
        break;
      default:
        Content = (
          <CardContent
            key='card-content'
            {...appearanceProps}
            title={title}
            subtitle={subtitle}
            description={description}
            actionLabel={actionLabel}
            onClick={() => {}}
          />
        );
    }

    let Card;
    const commonProps = Object.assign({}, rest, {
      compact: compact ? 'true' : 'false',
      'aria-label': a11yLabel,
      tabIndex: '0',
      role: 'group',
      to: link,
      onClick,
      target,
      type,
    });

    switch (type) {
      case 'icon':
        Card = (
          <CardIcon
            {...commonProps}
            icon={icon}
            title={title}
            accent={accent}
          />
        );
        break;
      case 'link':
        Card = (
          <CardLink
            {...commonProps}
            title={title}
          />
        );
        break;
      default:
        Card = (
          <StyledCard
            {...commonProps}>
            {Thumbnail}
            {Content}
          </StyledCard>
        );
    }

    return Card;
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/elements/Card/Card.jsx